/**
 * "Use another account" ends the SSO cookie via a full-page redirect through `/connect/logout` and back
 * to `/login` — React Router state doesn't survive that round trip, so this flag rides in sessionStorage
 * instead. `post_logout_redirect_uri` can't carry it: OpenIddict requires an exact match against the
 * client's registered logout URI, so no extra query string can be appended there.
 */

const SWITCH_ACCOUNT_KEY = 'sso_switch_account'

export const markSwitchAccount = (): void => {
  sessionStorage.setItem(SWITCH_ACCOUNT_KEY, '1')
}

/** Reads and clears the flag in one step so a page refresh or back-navigation doesn't replay it. */
export const consumeSwitchAccountFlag = (): boolean => {
  const value = sessionStorage.getItem(SWITCH_ACCOUNT_KEY)
  sessionStorage.removeItem(SWITCH_ACCOUNT_KEY)
  return value === '1'
}
